import React, { useEffect, useState } from 'react';
import Welcome from '../components/Welcome';
import EnhancedServices from '../components/EnhancedServices';
import About from '../components/About';
import ServiceModal from '../components/ServiceModal';

const Home = () => {
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (window.scrollY > 100) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="home-page">
      <Welcome />
      <EnhancedServices 
        isHomepage={true} 
        onServiceSelect={setSelectedService}
      />
      <About isHomepage={true} />
      
      {/* Service Modal */}
      <ServiceModal 
        serviceId={selectedService}
        isOpen={selectedService !== null}
        onClose={() => setSelectedService(null)}
      />
    </div>
  );
};

export default Home;